import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FontWeights, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	color: ${palette('white')};
	text-align: left;
`;

export const Title = styled(Text).attrs({
	el: 'h1',
	styleAs: 'h2',
	weight: FontWeights.Regular,
	noMargin: true,
})`
	margin-bottom: 4px;
`;

export const ButtonWrapper = styled.div`
	display: grid;
	grid-column-gap: 32px;
	grid-template-columns: 1fr 1fr;
	margin-bottom: 32px;
`;

export const TrailerButton = styled(Button)`
	background: rgba(0, 0, 0, 0.2);
	border: 2px ${palette('white')} solid;
`;

export const Description = styled.p`
	font-weight: 400;
	margin-bottom: 24px;
`;
